import React from 'react'

export const intermediatePageArray = (current, length) => {
    const arrayRange = (start, stop) =>
        Array.from(
            { length: (stop - start) + 1 },
            (value, index) => start + index
        );
    let min;
    let max;
    if (length <= 2) {
        return [];
    }
    if (length <= 5) {
        min = 1
        max = length - 2;
        return arrayRange(min, max);
    }
    min = Math.max(1, current - 1)
    if (min == 2) min = 1;
    max = Math.min(length - 2, current + 1)
    if (max == length - 3) max = length - 2;
    return arrayRange(min, max);
}

export const RowActions = (props) => {
    const id = props.id
    const editUser = () => {
        props.function1(
            id
        );
    }
    const deleteUser = () => {
        props.function2(
            id
        );
    }
    return (
        <div>
            <button type="button" className="btn btn-xs btn-default edit" id="btnEdit" data-locale="Edit" onClick={() => editUser()}>Edit</button>
            <button type="button" className="btn btn-xs btn-danger remove" id="btnDelete" data-locale="Delete" onClick={() => deleteUser()}>Delete</button>
        </div>
    )
}

export const SingleAction = (props) => {
  const id = props.id
  const status = props.status
  const toggleStatus = () => {
      props.function(
          id
      );
  }
  
  const isActive = status === 1
  const buttonLabel = isActive ? 'Deactivate' : 'Activate'
  const buttonClass = isActive ? 'btn btn-xs btn-outline-danger' : 'btn btn-xs btn-outline-success'
  
  return (
      <div>
          <button type="button" className={buttonClass} onClick={() => toggleStatus()}>{buttonLabel}</button>
      </div>
  )
}

export const ShowRole = (rowData) => {
    const role = rowData.row.original.super_user;
    let text = "ADMIN";
    if (role == 0) {
      text = "USER";
    }
    return (
      <span className={`badge badge-lg  ${role == 1 ? 'badge-info' : 'badge-light'}`} >
        {text}
      </span>
    )
  }

export const ShowDate = (rawDate) => {
  if(rawDate.row === null){
    return (<span>Not verified</span>)
  }
  const date = new Date(rawDate.row)
  if(isNaN(date.getTime())){
    return (<span>Invalid date</span>)
  }
  const dateString = date.toISOString().split('T')[0]
  return (
    <span>{dateString}</span>
  )
}

 export const ShowStatus = (rowData) => {
    const status = rowData.row.original.status;
    let text = "ACTIVE";
    if (status == 0) {
      text = "INACTIVE";
    }
    return (
      <span className={`badge badge-lg  ${status == 1 ? 'badge-success' : 'badge-neutral'}`} >
        {text}
      </span>
    )
  }

export const IndeterminateCheckbox = ({ indeterminate, ...rest }) => {
    const ref = React.useRef(null);
  
    React.useEffect(() => {
      if (typeof indeterminate === "boolean") {
        ref.current.indeterminate = !rest.checked && indeterminate;
      }
    }, [ref, indeterminate]);
  
    return <input type="checkbox" ref={ref} {...rest} />;
}

export const licenseOptionMap = [
    {
        "name": "com.zuragon.source.GPS",
        "alias": "GPS",
        "option": 0,
        "key": "9d51a18a32b39f0c"
    },
    {
        "name": "com.zuragon.image.processor.LaneDetector",
        "alias": "Lane detection",
        "option": 0,
        "key": "eb179f2f918245c5"
    },
    {
        "name": "com.zuragon.presenter.GoogleMaps",
        "alias": "Google Maps",
        "option": 0,
        "key": "e5d32c8795194546"
    },
    {
        "name": "com.zuragon.image.processor.NumberPlateDetector",
        "alias": "Number Plate Detector",
        "option": 0,
        "key": "d9e7edc13ed24769"
    },
    {
        "name": "com.zuragon.image.processor.VehicleDetector",
        "alias": "Vehicle detection",
        "option": 0,
        "key": "d9e7edc13ed24769"
    },
    {
        "name": "com.zuragon.source.HeartRateMonitor",
        "alias": "Heart Rate Monitor",
        "option": 0,
        "key": "79f710bbfbcc4d69"
    },
    {
        "name": "com.zuragon.source.LIN",
        "alias": "LIN",
        "option": 0,
        "key": "a57df434e8a24954"
    },
    {
        "name": "com.zuragon.presenter.SoundVisualizer",
        "alias": "Sound Visualizer",
        "option": 0,
        "key": "06b94246ab6e41f3"
    },
    {
        "name": "com.zuragon.video.Network",
        "alias": "Network video",
        "option": 0,
        "key": "95abe28eb751317a"
    },
    {
        "name": "com.zuragon.source.Sound",
        "alias": "Sound",
        "option": 0,
        "key": "30ec1a686e7f4e3f"
    },
    {
        "name": "com.zuragon.gps.GPSd",
        "alias": "GPSd service",
        "option": 0,
        "key": "a9e7eda12ed24764"
    },
    {
        "name": "com.zuragon.source.Ethernet",
        "alias": "Ethernet",
        "option": 0,
        "key": "71c27b3671a84522"
    },
    {
        "name": "com.zuragon.presenter.BaiduMaps",
        "alias": "Baidu Maps",
        "option": 0,
        "key": "782e6c28e3f5efb6"
    },
    {
        "name": "com.zuragon.presenter.VelodyneLiDAR",
        "alias": "Velodyne LiDAR",
        "option": 0,
        "key": "537eabe08eab14c5"
    },
    {
        "name": "com.zuragon.core.Programming",
        "alias": "Programming",
        "option": 0,
        "key": "024c99c403ff8f63"
    },
    {
        "name": "com.zuragon.core.Telematics",
        "alias": "Telematics",
        "option": 0,
        "key": "91ff1f5aa213d315"
    },
    {
        "name": "com.zuragon.qml.Matlab",
        "alias": "MATLAB integration",
        "option": 0,
        "key": "b6dc9a402aa2041f"
    },
    {
        "name": "com.zuragon.source.GoPro",
        "alias": "Go Pro camera",
        "option": 0,
        "key": "982c16d223453b2a"
    },
    {
        "name": "com.zuragon.source.CANFd",
        "alias": "CAN FD",
        "option": 0,
        "key": "8e2220258425624c"
    },
    {
        "name": "com.zuragon.source.FlexRay",
        "alias": "FlexRay",
        "option": 0,
        "key": "bc10bc4b21286a97"
    },
    {
        "name": "com.zuragon.presenter.MultiScreen",
        "alias": "Multi screen support",
        "option": 0,
        "key": "40a7e0b9e9b7dc19"
    },
    {
        "name": "com.zuragon.module.IBEO",
        "alias": "IBEO",
        "option": 0,
        "key": "c8a12caf1896dd17"
    },
    {
        "name": "com.zuragon.module.R",
        "alias": "R math",
        "option": 0,
        "key": "99ae871d2b45153c"
    },
    {
        "name": "com.zuragon.source.MccDAQ",
        "alias": "Mcc DAQ",
        "option": 0,
        "key": "fd3ef59f5f071362"
    },
    {
        "name": "com.zuragon.module.XCP",
        "alias": "XCP calibration",
        "option": 0,
        "key": "2cf749e9b67b1a38"
    },
    {
        "name": "com.zuragon.video.GigEVision",
        "alias": "Robosense LiDAR",
        "option": 0,
        "key": "86a8af386d4342d7"
    },
    {
        "name": "com.zuragon.video.SXProFrame",
        "alias": "Solectrix Pro Frame",
        "option": 0,
        "key": "ad05472e096a6dd3"
    },
    {
        "name": "com.zuragon.presenter.PandarLiDAR",
        "alias": "Pandar LiDAR",
        "option": 0,
        "key": "bb3d5406cac511e8"
    },
    {
        "name": "com.zuragon.presenter.RobosenseLiDAR",
        "alias": "GigE Vision network cameras",
        "option": 0,
        "key": "92571b8f5d4c7ddf"
    },
    {
        "name": "com.zuragon.image.preprocessor.LaneDetectorPRO",
        "alias": "Lane detector PRO",
        "option": 0,
        "key": "ac2e4d89129b9cc5"
    },
    {
        "name": "com.zuragon.image.processor.LaneDetectorPRO",
        "alias": "Lane detector PRO???",
        "option": 0,
        "key": "ac2e4d89129b9cc5"
    }
];